import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizeStyles = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl',
    xl: 'max-w-6xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-370">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-371">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-372" />

        <div className={`relative bg-white rounded-lg shadow-xl w-full ${sizeStyles[size]}`} data-id="element-373">
          <div className="flex items-center justify-between p-6 border-b border-slate-200" data-id="element-374">
            <h2 className="text-xl font-semibold text-slate-900" data-id="element-375">{title}</h2>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors" aria-label="Close modal" data-id="element-376">
              <XIcon className="w-5 h-5" data-id="element-377" />
            </button>
          </div>

          <div className="p-6" data-id="element-378">{children}</div>
        </div>
      </div>
    </div>;
}